import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-down-right', 'ChevronDownRight', [["path",{"d":"M16 8v8h-8"}]]);